import axiosConfig from '../../axiosConfig';

export const searchProduct = async (query) => {
    try {
        const response = await axiosConfig.get(`/api/products/search?q=${query}`); // Call your protected API endpoint
        return response.data.products; // Return the data from the response
    } catch (error) {
        console.log('Error fetching protected data:', error);
        // throw error; // Handle error appropriately
        
    }
};